module.exports = __webpack_public_path__ + "static/media/EHS-Code-of-Conduct-for-Workers-1.ee293be0.pdf";